import React from 'react'
import { Container, Typography, Link } from '@material-ui/core'
import { List, ListItem, ListItemText } from '@mui/material'
import makeStyles from './style'
import iso9001 from '../images/iso9001.jpg'
import certificadoiso from '../images/certificadoiso.jpg'
import ctfpdf from '../images/CERTIFICADO.pdf'




export default function SGQ() {
    const {bigContainer, container, isocontainer, title, titleSgq, subtitleSgq, revisionSGQ, description, isoImage, certificadoisoImg} = makeStyles()


    const valores = ['Agilidade', 'Comprometimento', 'Qualidade', 'Responsabilidade',
    'Respeito', 'Ética', 'Reinvestimento', 'Resultado (desempenho ou performance)']

    const politica = ['Respeitar os compromissos assumidos, visando sempre à satisfação de nossos clientes;',
     'A melhoria contínua de nossos processos, serviços e Sistema de Gestão;',
    'Capacitar nossos profissionais;', 'Manter um bom ambiente de trabalho aos nossos colaboradores;',
    'Atender aos requisitos aplicáveis e do Sistema de Gestão implantado.']

    return (
        <Container className={bigContainer}>
            <Container className={container} style={{backgroundColor: 'white'}}>
                <Typography className={titleSgq}>COMPROMISSO COM A QUALIDADE</Typography>
                <div  style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <img src={iso9001} className={isoImage} alt='Certificado ISO 9001' />
                </div>
                <Typography className={titleSgq}>O SEU CAMINHO PARA O SUCESSO</Typography>
                <Typography className={subtitleSgq}>QUALIDADE E RAPIDEZ NO ATENDIMENTO</Typography>
            </Container> 
            <Container className={container}>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Missão
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                Prover serviços de usinagem com qualidade, preço justo e uma operação rentável, 
                que assegure o crescimento sustentável da empresa e poder compartilhar o resultado com nossos colaboradores. 
                </Typography>
            </Container>
            <Container className={container}>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Visão
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                Consolidar nossa clientela regional e expandir para novos mercados, buscando sempre a rentabilidade e 
                satisfação de nossos clientes, para que permita o crescimento sustentável da empresa. 
                </Typography>
            </Container>
            <Container className={container}>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Valores
                </Typography>
                <List>
                    <li>
                    <ul>
                        {valores.map((item, index) => (
                        <ListItem key={index}>
                            <ListItemText primary={item} />
                        </ListItem>
                        ))}
                    </ul>
                    </li>
                </List>
            </Container>
            <Container className={container}>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Política de qualidade
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                A M A Serviços de Usinagem Ltda tem como Política fornecer serviços de usinagem atendendo às 
                expectativas de seus clientes, seguindo os seguintes princípios: 
                    <List>
                        <li>
                        <ul>
                            {politica.map((item, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={item} />
                            </ListItem>
                            ))}
                        </ul>
                        </li>
                    </List>
                </Typography>
                <br/>
                <Typography gutterBottom component='div' className={revisionSGQ}>
                    Revisão: 02<br/>
                    Data: 27/10/2017<br/>
                </Typography>
            </Container>
            <Container className={isocontainer} >
                <div>
                    <Link href={ctfpdf}>
                    <img src={certificadoiso} className={certificadoisoImg} alt='Certificado ISO 9001' />
                    </Link>
                </div>
                <Container style ={{'@media (min-width: 960px)': { marginLeft: '5vw'}}}>
                    <Typography gutterBottom variant='h4' component='div' className={title}>
                    Certificação ISO9001:2015
                    </Typography>
                    <Typography gutterBottom variant='h5' component='div' className={title}>
                    Sistema da Gestão da Qualidade
                    </Typography>
                    <Typography variant='body2' color='text.secondary' className={description}>
                    Desde o seu início a M.A. Serviços de Usinagem se preocupa com a qualidade dos serviços oferecidos. 
                    <br />
                    <br />
                    Nosso Sistema de Gestão da Qualidade da M.A foi implementado em 2012 servindo como ferramenta para: 
                    identificar, organizar e gerenciar os processos da M.A., a fim de garantir a qualidade de nossos produtos e/ou serviços, 
                    assim como a melhoria continua e satisfação de nossos clientes. O SGQ da M.A. atende aos requisitos aplicáveis da norma 
                    ISO 9001:2015, a qual fomos certificados para o escopo de “Prestação de Serviços de Usinagem”. 
                    <br />
                    <br />
                    Superar as expectativas é nossa meta! 
                    </Typography>
                </Container>
            </Container>
        </Container>
    )
}